export default __webpack_public_path__ + "static/media/notfound404.e414e2ef.svg";